<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Carteiras</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu das empresas">
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="cleanInvalidsCnpj()"
                      v-b-tooltip.hover
                      title="Limpar os registros de tentativas de CNPJs inválidos que são utilizados na sincronização com o Sintregra!"
                    >
                      <i class="fas fa-trash"></i>&nbsp; Limpar tentativas CPNJ inválido
                    </span>
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="companiesSync('contaazul')"
                      v-b-tooltip.hover
                      title="Sincronizar com a Conta Azul!"
                    >
                      <i class="fas fa-sync-alt"></i>&nbsp; Conta Azul
                    </span>
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="companiesSync('mktzap')"
                      v-b-tooltip.hover
                      title="Sincronizar os Clientes do MktZap!"
                    >
                      <i class="fas fa-sync-alt"></i>&nbsp; MktZap
                    </span>
                    <span
                      class="btn btn-outline-brand"
                      @click="openSaveCompany('add')"
                      v-b-tooltip.hover
                      title="Novo Cliente!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Cadastrar
                    </span>
                  </div>
                </div>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
                ref="alert"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount == 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount == 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Carteira
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'id'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        :class="{ 'table-sorted': sortType == 'ref_id' }"
                        @click="sortCall('ref_id')"
                      >
                        ID MktZap
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'ref_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'ref_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'ref_id'"></span>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="200"
                        :class="{ 'table-sorted': sortType == 'name' }"
                        @click="sortCall('name')"
                      >
                        Carteiras
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'name' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'name' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'name'"></span>
                      </td>
                      <td nowrap class="text-center align-middle" width="150">Documento</td>
                      <td nowrap class="text-center align-middle" width="50">Status</td>
                      <td nowrap class="text-center align-middle" width="80">Ações</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.ref_id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectCompanyStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td class="text-center align-middle" nowrap>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-sm"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(company, id) in data.data" :key="id">
                      <td class="text-center align-middle" v-b-tooltip.hover>
                        {{ company.id }}
                      </td>
                      <td class="text-center align-middle" v-b-tooltip.hover>
                        {{
                          company.products && company.products[0] && company.products[0].pivot
                            ? company.products[0].pivot.ref_id
                            : ''
                        }}
                      </td>
                      <td class="text-left align-middle">{{ company.name }}</td>
                      <td class="text-center align-middle">{{ company.cnpj | cnpj | cpf }}</td>
                      <td nowrap class="text-center align-middle pointer">
                        <span
                          class="m--font-warning"
                          v-if="company.status == 0"
                          @click="changeStatus(company.id)"
                          ><i class="fal fa-toggle-off fa-2x" v-b-tooltip.hover title="Inativo"></i
                        ></span>
                        <span
                          class="m--font-success"
                          v-if="company.status == 1"
                          @click="changeStatus(company.id)"
                          ><i class="fas fa-toggle-on fa-2x" v-b-tooltip.hover title="Ativo"></i
                        ></span>
                      </td>
                      <td nowrap class="text-center align-middle">
                        <a
                          href="#"
                          @click.prevent.stop="openSaveCompany(company.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Cadastro"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CompanyModal v-if="showCompanySave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCompanySave"
          @click="closeSaveCompany()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import CompanyModal from '@/components/companies/CompanyModal';
import SelectCompanyStatuses from '@/components/forms/SelectCompanyStatuses';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin, returnMessageMixin, validationFilterValueMixin],
  name: 'Companies',
  components: { CompanyModal, SelectCompanyStatuses },
  data() {
    return {
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      data: {},
      sortType: localStorage.companiesSortType ? localStorage.companiesSortType : 'name',
      sortReverse: localStorage.companiesSortReverse
        ? JSON.parse(localStorage.companiesSortReverse)
        : false,
      amount: localStorage.companiesDataAmount ? localStorage.companiesDataAmount : 100,
      page: localStorage.companiesDataPage ? localStorage.companiesDataPage : 1,
      filters: {
        id: localStorage.companiesFilterId ? localStorage.companiesFilterId : '',
        ref_id: localStorage.companiesFilterRefId ? localStorage.companiesFilterRefId : '',
        name: localStorage.companiesFilterName ? localStorage.companiesFilterName : '',
        cnpj: localStorage.companiesFilterCnpj ? localStorage.companiesFilterCnpj : '',
        status: localStorage.companiesFilterStatus ? localStorage.companiesFilterStatus : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCompanySave() {
      return this.$store.state.showCompanySave;
    },
  },
  methods: {
    changeStatus(companyId) {
      const url = `${baseApiUrl}/v1/company/status/${companyId}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
      this.callData();
    },
    cleanInvalidsCnpj() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: `Limpandos registros`,
        reason: '',
      };

      const url = `${baseApiUrl}/v1/company/sync/cleanreceitacontrol`;
      axios
        .get(url)
        .then((res) => {
          this.logMessageForm(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    companiesSync(location) {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: `Sincronizando ${location == 'contaazul' ? 'Conta azul' : 'MktZap'}`,
        reason: '',
      };

      const url = `${baseApiUrl}/v1/company/sync/${location}`;
      axios
        .get(url)
        .then((res) => {
          this.logMessageForm(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.ref_id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.sortType = 'name';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('companiesFilterId', this.filters.id);
      localStorage.setItem('companiesFilterRefId', this.filters.ref_id);
      localStorage.setItem('companiesFilterName', this.filters.name);
      localStorage.setItem('companiesFilterCnpj', this.filters.cnpj);
      localStorage.setItem('companiesFilterStatus', this.filters.status);
      localStorage.setItem('companiesDataAmount', this.amount);
      localStorage.setItem('companiesDataPage', this.page);
      localStorage.setItem('companiesSortType', this.sortType);
      localStorage.setItem('companiesSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&ref_id=${this.filters.ref_id ? this.filters.ref_id : ''}&name=${
        this.filters.name ? this.filters.name : ''
      }&cnpj=${this.filters.cnpj ? this.filters.cnpj : ''}&status=${
        this.filters.status ? this.filters.status : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }`;
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/company/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    openSaveCompany(id) {
      this.$store.state.showCompanySave = id;
    },
    closeSaveCompany() {
      this.$store.state.showCompanySave = null;
      this.callData();
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
